import { getReportBreadcrumb } from '@/lib/utils/breadcrumbs'
import { createFileRoute } from '@tanstack/react-router'
import { ReportDetailsEmbed, reportEmbedFiltersSchema } from '../-components/ReportDetailsEmbed'

export const Route = createFileRoute('/_auth/_modules/_app/reports/order-service/$reportId')({
  component: ReportDetails,
  validateSearch: reportEmbedFiltersSchema,
  loader: async ({ params: { reportId } }) => {
    const crumb = await getReportBreadcrumb(reportId)
    return { crumb }
  },
})

function ReportDetails() {
  const { reportId } = Route.useParams()
  const filters = Route.useSearch()

  return <ReportDetailsEmbed reportId={reportId} filters={filters} />
}
